// TSS vite/05 — client-side replica of the server's authorize() wildcard
// semantics. Source of truth: cowre_ultimate/middlewares/auth/authorize.js.
// Keep this in lockstep with the backend matcher — do NOT invent rules.
//
//   matches('*',         anything)        → true   (superuser / webmaster)
//   matches('animals:*', 'animals:read')  → true   (resource wildcard)
//   matches('animals:read', 'animals:read') → true (exact)
//
// `grants` are the patterns AS-IS from GET /auth/me → permissions.grants
// (decisions/0008): wildcards are matched here, never pre-expanded.

export function matchesGrant(granted, required) {
    if (granted === '*' || granted === required) return true;
    if (granted.endsWith(':*')) {
        const prefix = granted.slice(0, -1); // 'animals:*' -> 'animals:'
        return required.startsWith(prefix);
    }
    return false;
}

// Accepts either can('animals', 'read') or can('animals:read') — when no
// action is given, `domain` is treated as the full 'resource:action' string.
export function canFromGrants(permissions, domain, action) {
    if (!domain) return true;
    if (permissions?.superuser) return true;
    const required = action ? `${domain}:${action}` : domain;
    const grants = permissions?.grants;
    return Array.isArray(grants) && grants.some((g) => matchesGrant(g, required));
}
